import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OilCollectionService } from '../../../../../services/customers/oil-collection.service';
import * as wjcCore from '@grapecity/wijmo';
import { ClientsService } from '../../../../../services/customers/clients.service';

@Component({
    selector: 'app-remote-oil-collection-modal',
    templateUrl: './remote-oil-collection-modal.component.html',
    styleUrls: ['./remote-oil-collection-modal.component.scss'],
    standalone: false
})
export class RemoteOilCollectionModalComponent implements OnInit {
  @Input() routeId?: string;
  
  form!: UntypedFormGroup;
  routes: any[] = [];
  clients: any[] = [];
  loading = false;
  loadingClients = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private oilCollectionService: OilCollectionService,
    private toastr: ToastrService,
    private clientService: ClientsService,
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  getAllClients(query: string = '') {
    this.loadingClients = true;
    this.clientService.getAllAsync(1, 21, query)
      .then((records: any) => {
        this.clients = records.clients;
        this.loadingClients = false;
      })  
      .catch(() => {
        this.loadingClients = false;
      });
  }

  createForm() {
    this.form = this.fb.group({
      date_start: ['', Validators.required],
      date_end: ['', Validators.required],
      route: [this.routeId ?? null, Validators.required],
      client: [null, Validators.required],
      gallons: ['', Validators.required],
      input_notes: [''],
    });

    this.form.get('date_end')?.valueChanges.subscribe(() => {
      this.getRoutes();
    });

    this.form.get('date_start')?.valueChanges.subscribe(() => {
      this.getRoutes();
    });
  }

  getRoutes() {
    const { date_start, date_end } = this.form.value;
    if (!date_start || !date_end) return;

    let params = { date_start, date_end };

    this.oilCollectionService.getRoutes(params).subscribe((data: any) => {
      this.routes = data.routes.map((value: any) => ({
        ...value,
        name_route: value.driver.name + ' - ' + wjcCore.Globalize.format(new Date(value.created_at), 'f')
      }));
    });
  }

  onClientQuerySearch(q: string) {
    this.getAllClients(q);
  }

  onClientSelected(client: any) {
    this.form.get('client')?.setValue(client?._id);
  }

  save() {
    if (this.form.invalid) {
        this.toastr.warning('Please fill all required fields');
        return;
    }

    this.loading = true;
    const selectedClient = this.clients.find((client: any) => client._id === this.form.value.client);
    const selectedRoute = this.routes.find((route: any) => route._id === this.form.value.route);
    let payload = { ...this.form.value, client: selectedClient, route: selectedRoute, client_ident_GUI: 0 };

    if(!selectedRoute) {
      this.toastr.warning('The route not exist or not in range of selected dates');
      return;
    }

    this.oilCollectionService.saveRoute(payload).subscribe(
      (data: any) => {
        this.loading = false;
        if (data.status === 'OK') {
          this.toastr.success('The manual collection is saved');
          this.activeModal.close(true);
        } else {
          this.toastr.warning('The manual collection request failed, please retry');
        }
      },
      (error) => {
        this.loading = false;
        this.toastr.error('Server Error');
      }
    ); 
  }
}
